import {ref, reactive, toRefs, computed,watch,defineComponent,onBeforeMount,onMounted,getCurrentInstance,provide,nextTick} from 'vue';
import SysTitleCardUtil,{ISysTitleCardDataObj} from './sysTitleCardUtil';
export default defineComponent({
    name:'SysTitleCard',
    title:'系统标题',
    modelType:'card',
    fullscreen: false,
    setup(){
        let {proxy}=getCurrentInstance() as any;
        const utils=proxy.utils;
        let dataObj:ISysTitleCardDataObj=reactive<ISysTitleCardDataObj>({
            utilInst:{} as any,
            formRef:null,
            disabled:false,
            refMap:new Map(),
            corpTreeData:[],
            //卡片传给dialog的初始化参数
            compParams: {
                hsDetails: false,
                modelPath: utils.Api.buildUrl('/sysTitle')
            },
            //表单
            form:{},
            //表单验证规则
            rules: {
                corpId: [utils.UtilPub.commonValidRule('请选择机构')],
                title: [utils.UtilPub.commonValidRule('请输入系统标题')],
            }
        })
        onBeforeMount(()=>{
            dataObj.utilInst=new SysTitleCardUtil(proxy,dataObj);
        })
        onMounted(()=>{
            nextTick(async()=>{
                await dataObj.utilInst.buildSelectData();
            })
        })
        //---------------------------computed---------------------------
        //cascader数据集获取（静态数据集可参考下方select，动态的在beforeOpen中去请求后台构建，然后赋值给dataObj中相关项）
        const cascaderData=computed(()=>{
            return (params:any) => {
                if(params && 'corpId'==params.comboId){
                    return dataObj.corpTreeData;
                }
            }
        })
        //--------------------------cascaderOnchange-------------------------
        const cascaderOnChange=(newValue:string,cascaderId:string)=>{
            if('corpId'==cascaderId){}
        }
        //打开弹出框的回调事件(已请求完/add或/edit，data是返回值)
        const beforeOpen=async(res:any,addOrLoad:string,engineInst:any)=>{
            dataObj.corpTreeData = await utils.Api.corpTreeData();
        }
        //保存之前，校验整个保存数据是否合法
        const beforeSaveHandler=()=>{
            return true;
        }
        return{
            ...toRefs(dataObj),cascaderData,cascaderOnChange,beforeOpen,beforeSaveHandler
         
        }
    }
});